import { getTemplateUrlWithBiParam } from '../utils/getTemplateUrlWithBiParam';
import { useHttpClient } from '@wix/fe-essentials/react';
import { createBlocksAppFromTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/http';
import { useTemplatesData } from './useTemplatesData';
import { useLoginNavigation } from './useLoginNavigation';
import { useCallback, useEffect, useState } from 'react';
import { QueryParams } from '../constants/QueryParams';
import { REFERRAL_INFO } from '../constants/routes';
import { wait } from '../utils/general';
import { NamespaceType } from '@wix/ambassador-devcenter-apps-v1-app/types';
import { useQueryParams } from './useQueryParams';
import { useEssentials } from '@wix/fe-essentials-standalone';

export const useOpenBlocksEditorUrl = () => {
  const { isUserLoggedIn } = useTemplatesData();
  const httpClient = useHttpClient();
  const { getParam } = useQueryParams();
  const { panoramaClient } = useEssentials();
  const templateId = getParam(QueryParams.TEMPLATE_ID);
  const templateName = getParam(QueryParams.TEMPLATE_NAME);
  const templateNamespace = getParam(QueryParams.TEMPLATE_NAMESPACE);
  const templateNamespaceType =
    getParam(QueryParams.TEMPLATE_NAMESPACE_TYPE) === NamespaceType.COMPANY
      ? NamespaceType.COMPANY
      : NamespaceType.ACCOUNT;
  const isReturnedFromLoginPage = getParam(
    QueryParams.RETURNED_FROM_LOGIN_PAGE,
  );
  const [isError, setIsError] = useState(false);

  const navigateToLoginPage = useLoginNavigation();

  const openBlockUrl = useCallback(async () => {
    try {
      if (!isUserLoggedIn) {
        navigateToLoginPage(REFERRAL_INFO.BLOCKS_TEMPLATE_FLOW);
      } else {
        if (isReturnedFromLoginPage) {
          await wait(2000); // Temporary, we need to wait until blocks is added to userProfile
        }
        const { data } = await httpClient.request(
          createBlocksAppFromTemplate({
            templateId,
            templateConfig: {
              appInfo: {
                name: templateName,
                namespace: templateNamespace,
                namespaceType: templateNamespaceType,
              },
            },
          }),
        );
        const urlParams = new URLSearchParams(window.location.search);
        const httpReferrer = urlParams.get(QueryParams.HTTP_REFERRER);
        const entryFlow = urlParams.get(QueryParams.ENTRY_FLOW);

        window.location.assign(
          getTemplateUrlWithBiParam(data.editorUrl, httpReferrer, entryFlow),
        );
      }
    } catch (e) {
      panoramaClient.errorMonitor().reportError(e);
      setIsError(true);
    }
  }, []);

  useEffect(() => {
    void openBlockUrl();
  }, []);

  return { isError };
};
